import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getDssInfoSection = async () => {
  const data = await fetchData(ENDPOINTS.GET.DSS_INFO_SECTION, {
    method: METHODS.GET,
  });
  return data.map(({ acf }) => acf);
};
